export const URL_SERVICIOS = 'http://facturacion.printerstore.mx/api/';